import { DROPDOWN_ACTION_TEXT } from '../constants/index';

export type AccountProperties = {
  isPrimaryAccount: boolean;
  isOrgOwned: boolean;
  isLoggedInAccountNotPrimary?: boolean;
};

export type DropdownActions = {
  unlinkAccount: () => Promise<void>;
  changePrimary: () => void;
  makePrimary: () => void;
};

export type Action = {
  text: string;
  onClick: () => void;
};

const isChangePrimaryDisabled = true;

export const linkedAccountDropdownActions = (
  accountProperties: AccountProperties,
  dropdownActions: DropdownActions,
): Action[] => {
  const {
    isPrimaryAccount,
    isOrgOwned,
    isLoggedInAccountNotPrimary = false,
  } = accountProperties;

  if (isLoggedInAccountNotPrimary) {
    return [
      {
        text: DROPDOWN_ACTION_TEXT.UNLINK_ACCOUNT,
        onClick: dropdownActions.unlinkAccount,
      },
    ];
  }

  // Primary and NOT Org-Owned
  if (isPrimaryAccount && !isOrgOwned && !isChangePrimaryDisabled) {
    return [
      {
        text: DROPDOWN_ACTION_TEXT.CHANGE_PRIMARY,
        onClick: dropdownActions.changePrimary,
      },
    ];
  }

  // NOT Primary and NOT Org-Owned
  if (!isPrimaryAccount && !isOrgOwned) {
    return [
      {
        text: DROPDOWN_ACTION_TEXT.MAKE_PRIMARY,
        onClick: dropdownActions.makePrimary,
      },
      {
        text: DROPDOWN_ACTION_TEXT.UNLINK_ACCOUNT,
        onClick: dropdownActions.unlinkAccount,
      },
    ];
  }

  // NOT Primary and Org-Owned
  if (!isPrimaryAccount && isOrgOwned) {
    return [
      {
        text: DROPDOWN_ACTION_TEXT.UNLINK_ACCOUNT,
        onClick: dropdownActions.unlinkAccount,
      },
    ];
  }
  return [];
};
